import React from 'react';
import HeroComponent from '../components/HeroComponent';
import backgroundImage from '../assets/HomeBackground.png';
import { HowItWorks } from '../sections/home/HowItWorks';
import { Service, ServicesSection } from '../sections/ServicesSection';
import { ConnectUs } from '../sections/ConnectUs';
import { FiUsers, FiCompass, FiLayers, FiBell, FiEye } from 'react-icons/fi';
import { contactInfo } from '../config/navigation';

const services: Service[] = [
  {
    icon: FiUsers,
    title: 'Personalized, Client First Advisory',
    description:
      "As your advisor, our approach is simple: you first, always. Every recommendation is crafted around your dreams—whether it's building wealth, ensuring your child's bright future, or enjoying a stress-free retirement.",
  },
  {
    icon: FiCompass,
    title: 'Behavioral Coach',
    description:
      "We hold your hands. Throughout. Through market turbulence. Through euphoria. Because the difference between investment success and failure isn't what we buy, it's how we behave.",
  },
  {
    icon: FiLayers,
    title: 'Minimal Portfolio Overlap',
    description:
      'Leveraging specialized tools, minimal overlap ensures true diversification—not just the illusion of it to protect against sector shocks, concentration risk and redundancy',
  },
  {
    icon: FiBell,
    title: 'Proactive, Ongoing Engagement',
    description:
      'We offer timely insights, personalized guidance, and proactive alerts that help you navigate opportunities and risks.',
  },
  {
    icon: FiEye,
    title: 'Transparency',
    description:
      'We commit to full transparency in every aspect of our partnership. From explaining the costs and fees involved, to sharing detailed performance reports and rationale behind every recommendation, nothing is hidden or glossed over',
  },
];

export const Home: React.FC = () => (
  <>
    <HeroComponent
      backgroundImage={backgroundImage}
      title="More Than Advice. <br /> A Partnership for Life."
      subtitle="Start your financial journey with us."
      primaryButton={{ link: `https://wa.me/${contactInfo.phoneNumber}`, text: 'Contact US' }}
      secondaryButton={{ link: '/about', text: 'About US' }}
    />
    <HowItWorks />
    <ServicesSection
      heading="Wealth management that <em>grows</em> with you."
      subHeading="How we can help you"
      services={services}
    />
    <ConnectUs />
  </>
);
